export default __webpack_public_path__ + "static/media/sticker-j.4e169779.png";